import styled from 'styled-components';


export const Container = styled.div`

	div {
		height: 0.1rem;
		background: #3fb6fa;
		border-radius: 8px;
		margin-left: 1px;
	}

	div {
		animation-duration: 0.7s;
		animation-name: sliderin;
	}

	@keyframes sliderin {
		from{
			opacity: 0;
		}	
	}
`